import { apiClient } from "@base/api/client";
import { type UseQueryOptions, useQuery } from "@tanstack/react-query";
import { type ProjectTradesResponse, type TradeType, projectTradesResponseSchema } from "./projectTradesSchema";

async function fetchProjectTrades(
  projectId: string,
  keyword: string,
  type?: TradeType,
): Promise<ProjectTradesResponse> {
  const trimmed = keyword.trim();
  const params: Record<string, string> = {};
  if (trimmed) params.keyword = trimmed;
  if (type) params.type = type;
  const response = await apiClient.get<unknown>(`/project-management/api/projects/${projectId}/trades`, {
    params: Object.keys(params).length ? params : undefined,
  });
  return projectTradesResponseSchema.parse(response.data);
}

export function projectTradesQueryOptions(projectId: string, keyword: string, type?: TradeType) {
  const trimmed = keyword.trim();
  return {
    queryKey: ["project-trades", projectId, trimmed, type] as const,
    queryFn: () => fetchProjectTrades(projectId, keyword, type),
  };
}

export function useProjectTradesQuery(
  projectId: string,
  keyword: string,
  type?: TradeType,
  options?: Omit<UseQueryOptions<ProjectTradesResponse>, "queryKey" | "queryFn">,
) {
  return useQuery({
    ...projectTradesQueryOptions(projectId, keyword, type),
    ...options,
  });
}
